var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutubeBlack = function SvgYoutubeBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.641 10.8s-.351-2.482-1.434-3.572c-1.371-1.434-2.904-1.441-3.607-1.525-5.034-.366-12.593-.366-12.593-.366h-.014s-7.559 0-12.593.366c-.703.084-2.236.09-3.607 1.525C.71 8.318.366 10.8.366 10.8S0 13.718 0 16.63v2.727c0 2.911.359 5.83.359 5.83s.351 2.481 1.427 3.571c1.371 1.434 3.171 1.385 3.973 1.54 2.882.274 12.241.358 12.241.358s7.566-.014 12.6-.372c.703-.085 2.236-.092 3.607-1.526 1.083-1.09 1.434-3.572 1.434-3.572s.359-2.91.359-5.829V16.63c0-2.91-.359-5.829-.359-5.829ZM14.281 22.67V12.55l9.724 5.077-9.724 5.04Z",
    fill: "#191919"
  })));
};

export default SvgYoutubeBlack;